import React from 'react';
import { createRoot } from 'react-dom/client';
import {App} from './App';

if (process.env.NODE_ENV === 'production') {
  const script = document.createElement('script');
  script.setAttribute('disable-devtool-auto', '');
  script.src = 'https://cdn.jsdelivr.net/npm/disable-devtool';
  document.head.appendChild(script);
}

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
